module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAbElEQVQoU33QwRGAMAhE0Z/OtBLtRC3FSqKl2ImDIxmCCOe3kE0BKrABB/nUAgxvYEwCsvAULJMFHgisiv8CDQqw2AcW3ahVPLaBHZht5wjL6QuYgK60x/aNn9IWd2WiX1IcQX1uuyA4g13gBu03JIozCa6DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cross.png
// module id = 6qfX
// module chunks = 2